var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"contenedor-main-listado-eventos"}},[(!_vm.$vuetify.breakpoint.mobile)?[_c('desktop',{attrs:{"licitacionEventos":_vm.licitacionEventos}})]:[_c('mobile',{attrs:{"licitacionEventos":_vm.licitacionEventos}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }